import {
    AlertColor,
    Avatar,
    Box,
    Button,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import PageLoader from 'components/PageLoader';
import dayjs from 'dayjs';
import queryString from 'query-string';
import React, { RefObject, useCallback, useEffect, useRef, useState } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Notification from '../../components/Notification';
import { routes } from '../../utils/constants/routes';
import { URLS } from '../../utils/constants/urls';
import axiosInstance from '../../utils/redux/axios';
import { searchFormData, setVenueList, setInitialDate, initialDateForCalendar, setSearchFormData } from '../../utils/redux/reducer/searched-data-slice';
import { fetchFromStorage } from '../../utils/storage';
import strings from 'common/Translation/Translate';
import { Views } from 'utils/constants/data';
import CircleIcon from '@mui/icons-material/Circle';
import { EventContentArg } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import FullCalendar from '@fullcalendar/react';
import interactionPlugin from '@fullcalendar/interaction';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import moment from 'moment';
import { defaultLanguage } from 'utils/redux/reducer/authentication-slice';
import './calendarStyle.scss'
import { ClearOutlined, RadioButtonChecked } from '@mui/icons-material';
import Debounce from 'utils/validators/debounce';

const AvailableVenuesCalendar = ({ handleClose }: { handleClose?: any }) => {
    const location = useLocation();
    const initialDate = useSelector(initialDateForCalendar)
    const selectedLanguage = useSelector(defaultLanguage);
    const queryStringValues = queryString.parse(location.search);
    const theme = useTheme();
    const searchBarFormData = useSelector(searchFormData);
    const screenSizeDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const screenSizeDownSm = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const venueListData = useSelector(venueList);
    const [availableVenues, setAvailableVenues] = useState<any>([]);
    const searchData = useSelector(searchFormData);
    const selectedOrgId = queryStringValues.oid || JSON.parse(fetchFromStorage('selectedOrg', true) as string);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [showcalendarDateSelectBtn, setShowcalendarDateSelectBtn] = React.useState<boolean>(false);
    const [searchDate, setSearchDate] = React.useState<any>({ start: '', end: '' });
    // const [showcalendarDateSelectBtn, setShowcalendarDateSelectBtn] = React.useState<boolean>(false);
    // const [showcalendarDateSelectBtn, setShowcalendarDateSelectBtn] = React.useState<boolean>(false);
    const [viewType, setViewType] = useState<any>(Views.MONTH);
    const [message, setMessage] = useState<{
        display: boolean;
        severity: AlertColor | null;
        message: any;
    }>({
        display: false,
        severity: null,
        message: '',
    });
    let calendarRef: RefObject<any> = useRef();
    let calendarApi = calendarRef.current?.getApi();

    const getFirstAndLastDays = (newDate: any) => {
        const date = new Date(newDate);
        return {
            startDate: new Date(date.getFullYear(), date.getMonth(), 1),
            endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0),
        };
    };

    useEffect(() => {
        if (!selectedOrgId) {
            navigate(routes.root);
        }
    }, []);


    const closeNotification = (value: boolean) => {
        setMessage({ ...message, display: value });
    };

    const createQueryString = () => {
        // const dates = getFirstAndLastDays(initialDate);
        const date = new Date(initialDate);
        const dates = {
            startDate: new Date(date.getFullYear(), date.getMonth() - 1, 15),
            endDate: new Date(date.getFullYear(), date.getMonth() + 1, 15),
        };
        const queryStringData = {
            endDate: dayjs(dates.endDate).format('YYYY-MM-DD'),
            startDate: dayjs(dates.startDate).format('YYYY-MM-DD'),
        };
        return dates.startDate
            ? `startDate=${queryStringData.startDate}&endDate=${queryStringData.endDate}`
            : '';
    };

    const getVenueDetails = async () => {
        const requestBody = {
            location: searchData.location?.map((item: any) => item.value),
            eventType: searchData.eventType,
            bookingStartDate: dayjs(searchData.startDate as string).format('DD-MM-YYYY'),
            bookingEndDate: dayjs(searchData.endDate as string).format('DD-MM-YYYY'),
            // timeSlot: searchData.timeSlot,
            startTime: searchData.startTime,
            endTime: searchData.endTime,
            guest: searchData.guests,
            layouts: [],
        };
        try {
            setLoading(true);
            const queryString = createQueryString();
            const { data } = await axiosInstance.post(`${URLS.getAvailableVenuesCalendar(selectedOrgId)}?${queryString}`, requestBody);
            setAvailableVenues(data);
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            setMessage({
                display: true,
                severity: 'error',
                message: error.response.data.message,
            });
        }
    };

    useEffect(() => {
        const { startDate } = getFirstAndLastDays(searchData.startDate)
        calendarApi?.gotoDate(new Date(startDate));
        dispatch(setInitialDate(dayjs(startDate).format('YYYY-MM-DD')))
    }, [searchData]);

    useEffect(() => {
        if (searchData.eventType) getVenueDetails();
        else dispatch(setVenueList({}));
    }, [initialDate]);

    const WAITLISTED = 'WAITLISTED';
    const RFQ = 'RFQ';
    const AVAILABLE = 'AVAILABLE';
    // const UNAVAILABLE = 'UNAVAILABLE';
    // const HIGH_DEMAND = 'HIGH_DEMAND';

    const calendarFlag = (strings: any) => [
        { label: strings.availableText, status: AVAILABLE, class: 'text-success', color: '#2f9e46' },
        { label: strings.waitListText, status: WAITLISTED, class: 'text-primary', color: '#007bff' },
        { label: strings.RFQ, status: RFQ, class: 'text-primary', color: 'orange' },
        // { label: strings.unavailable_text, status: UNAVAILABLE, class: 'unavailableIcon', color: '#ffa9b0' },
        // { label: strings.highDemand_text, status: HIGH_DEMAND, class: 'highDemandIcon', color: '#18015e' },
    ];
    const handleDateNavigate = (type: any) => () => {
        if (type === 'add') {
            calendarApi.next();
        } else {
            calendarApi.prev();
        }
        dispatch(setInitialDate(dayjs(calendarApi?.getDate()).format('YYYY-MM-DD')));
    };
    const setToday = () => {
        calendarApi.today();
        dispatch(setInitialDate(moment(calendarApi?.getDate()).format('YYYY-MM-DD')));
    };
    const disableTodayButton = () => {
        const date = calendarApi?.getDate();
        const dates = getFirstAndLastDays(date);
        return moment().isBetween(moment(dates.startDate), moment(dates.endDate));
    };
    const displayDate = () => {
        const newDate = calendarApi?.getDate();
        return moment(newDate).locale(selectedLanguage?.value.substring(0, 2)).format('MMMM YYYY');
    };

    const getLabel = (screenSizeDownMd: any, screenSizeDownSm: any, title: any) => {
        if (screenSizeDownMd) return `${title.substring(0, 8)}...`
        else if (screenSizeDownSm) return `${title.substring(0, 3)}...`
        else return title
    }
    function renderEventContent(eventInfo: EventContentArg) {
        const { title, extendedProps } = eventInfo.event;
        const { status } = extendedProps;
        return (
            <Tooltip title={title}>
                <Box display={'flex'} gap={screenSizeDownSm ? 0.3 : 0.7} alignItems='center'
                    sx={{
                        width: '100%',
                        borderRadius: '5px',
                        pl: '2px',
                        py: '1px',
                    }}>
                    <CircleIcon sx={{ color: calendarFlag(strings).find((i: any) => i.status === status)?.color }} style={{ fontSize: '10px' }} />
                    <Typography fontSize={'11px'}>{getLabel(screenSizeDownMd, screenSizeDownSm, title)}</Typography>
                </Box>
            </Tooltip>
        );
    }

    const SlotDesign = (laneInfo: any) => {
        const start = moment(laneInfo.date).isSameOrAfter(moment(searchData.startDate), 'day')
        const end = moment(laneInfo.date).isSameOrBefore(moment(searchData.endDate), 'day')
        const blocked = availableVenues.filter((v: any) => moment(laneInfo.date).isSame(v.start, 'day')).length === 0
        if (blocked) {
            return <Typography textAlign={'right'} pr={0.5} sx={{ color: 'grey' }}>
                {laneInfo.dayNumberText}
            </Typography>
        }
        else if (start && end) {
            return (
                <Avatar sx={{ backgroundColor: '#18015e16', height: 30, width: 30, border: '1.6px solid #18015e' }}>
                    <Typography textAlign={'right'} color={'#18015e'} fontWeight={600} fontSize={'16px'}>
                        {laneInfo.dayNumberText}
                    </Typography>
                </Avatar>
            )
        }
        else {
            return <Avatar sx={{ backgroundColor: 'transparent', p: 0, height: 30, width: 30 }}>
                <Typography textAlign={'right'} color={'#000000'} fontWeight={600} fontSize='12px'>
                    {laneInfo.dayNumberText}
                </Typography>
            </Avatar>
        }
    }
    const optimizedFn = useCallback(
        Debounce((val: boolean) => setShowcalendarDateSelectBtn(val), 0),
        [],
    ) as any;

    const handleSelectSlot = (selectInfo: any) => {
        optimizedFn(true);
        const { startStr, endStr } = selectInfo
        setSearchDate({ start: moment(startStr).format('DD-MM-YYYY'), end: moment(endStr).subtract(1, 'days').format('DD-MM-YYYY') })
    };

    return (
        <>
            {loading && <PageLoader />}
            {message.display && (
                <Notification
                    isOpen={message.display}
                    message={message.message}
                    severity={message.severity as AlertColor}
                    closeNotification={closeNotification}
                />
            )}
            <Box sx={{ p: 2, position: 'relative' }}>
                {showcalendarDateSelectBtn &&
                    <div style={{ position: 'absolute', bottom: '7px', width: "97%", display: 'flex' }}>
                        <Button variant='contained' style={{
                            textTransform: 'capitalize', margin: '0 auto', zIndex: 100, fontSize: '14px', fontWeight: 600
                        }}
                            onClick={() => {
                                const body = {
                                    ...searchBarFormData,
                                    startDate: searchDate.start.split('-').reverse().join('-'),
                                    endDate: searchDate.end.split('-').reverse().join('-'),
                                }
                                dispatch(setSearchFormData(body))
                                handleClose();
                            }}>
                            {searchDate.start === searchDate.end ? `Search for ${searchDate.start}` : `Search for ${searchDate.start} to  ${searchDate.end}`}
                        </Button>
                    </div>

                }
                {screenSizeDownSm ?
                    <>
                        <Box display={'flex'} alignItems={'center'} mb={2} justifyContent={'space-between'}>
                            <Box display={'flex'} alignItems={'center'} gap={1} >
                                <Tooltip title={strings.prev_text} sx={{ ":hover": { backgroundColor: 'transparent' } }}>
                                    <Button onClick={handleDateNavigate('subtract')} variant="contained">
                                        <ArrowBackIosNewIcon sx={{ fontSize: '18px' }} />
                                    </Button>
                                </Tooltip>
                                <Tooltip title={strings.next_text}>
                                    <Button onClick={handleDateNavigate('add')} variant="contained">
                                        <ArrowForwardIosIcon sx={{ fontSize: '18px' }} />
                                    </Button>
                                </Tooltip>
                                <Button
                                    size="small"
                                    onClick={setToday}
                                    disabled={disableTodayButton()}
                                    variant="contained"
                                    sx={{ width: 'max-content', fontSize: '13px' }}>
                                    {strings.todayText}
                                </Button>
                            </Box>
                            <Box>
                                <ClearOutlined
                                    onClick={() => {
                                        const { startDate } = getFirstAndLastDays(searchData.startDate)
                                        calendarApi?.gotoDate(new Date(startDate));
                                        dispatch(setInitialDate(dayjs(startDate).format('YYYY-MM-DD')))
                                        handleClose();
                                    }}
                                    sx={{
                                        ':hover': { cursor: 'pointer' },
                                        color: theme.palette.primary.main,
                                    }}
                                />
                            </Box>
                        </Box>
                        <Typography variant='h6' fontWeight={600} color={'primary'}>{displayDate()}</Typography>
                    </>
                    :
                    <Box display={'flex'} alignItems={'center'} mb={2} justifyContent={'space-between'}>
                        <Typography variant='h5' fontWeight={600} color={'primary'}>{displayDate()}</Typography>
                        <Box display={'flex'} alignItems={'center'} gap={1} >
                            <Button
                                size="small"
                                onClick={setToday}
                                disabled={disableTodayButton()}
                                variant="contained"
                                sx={{ width: 'max-content', fontSize: '13px' }}>
                                {strings.todayText}
                            </Button>
                            <Tooltip title={strings.prev_text}>
                                <Button onClick={handleDateNavigate('subtract')} variant="contained">
                                    <ArrowBackIosNewIcon sx={{ fontSize: '18px' }} />
                                </Button>
                            </Tooltip>
                            <Tooltip title={strings.next_text}>
                                <Button onClick={handleDateNavigate('add')} variant="contained">
                                    <ArrowForwardIosIcon sx={{ fontSize: '18px' }} />
                                </Button>
                            </Tooltip>
                            <ClearOutlined
                                onClick={handleClose}
                                sx={{
                                    ':hover': { cursor: 'pointer' },
                                    color: theme.palette.primary.main,
                                }}
                            />
                        </Box>
                    </Box>
                }
                <div className={`calendar-container ${viewType}`}>
                    <Box display="flex" flexWrap={'wrap'} gap={1} alignItems="center" mb={1}>
                        {calendarFlag(strings).map((item: any) => (
                            <Typography display="flex" alignItems="center" key={item.class} fontSize="12px" fontWeight={400} >
                                <CircleIcon sx={{ mr: 0.5 }} fontSize="inherit" style={{ color: item.color }} /> {item.label}
                            </Typography>
                        ))}
                        <Typography display="flex" alignItems="center" key={'selected'} fontSize="12px" fontWeight={400}>
                            <RadioButtonChecked sx={{ mr: 0.5, fontSize: "15px", color: '#18015e' }} />{strings.selectedDateRange}
                        </Typography>
                    </Box>

                    <FullCalendar
                        validRange={{
                            start: dayjs().add(1, 'days').format('YYYY-MM-DD'),
                        }}
                        dayMaxEvents={2}
                        moreLinkContent={args => {
                            return `${args.shortText} ${strings.more}`;
                        }}
                        moreLinkClick={(info: any) => { console.log('info: ', info) }}
                        contentHeight={'70vh'}
                        ref={calendarRef}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        headerToolbar={false}
                        initialView={'dayGridMonth'}
                        selectable={true}
                        events={availableVenues.filter(
                            (item: any) => !(item.status === 'UNAVAILABLE' || item.status === 'HIGH_DEMAND'),
                        )}
                        eventContent={renderEventContent}
                        initialDate={initialDate}
                        dayCellContent={SlotDesign}
                        select={handleSelectSlot}
                        unselect={() => optimizedFn(false)}
                    />
                </div >
            </Box >
        </>
    );
};

export default AvailableVenuesCalendar;
